import { render, staticRenderFns } from "./department-boxes.vue?vue&type=template&id=7b2f474c&scoped=true"
import script from "./department-boxes.vue?vue&type=script&lang=js"
export * from "./department-boxes.vue?vue&type=script&lang=js"
import style0 from "./department-boxes.vue?vue&type=style&index=0&id=7b2f474c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2f474c",
  null
  
)

export default component.exports